import React, { useEffect } from 'react';
import {  useDispatch } from 'react-redux';
import { Route, useHistory } from "react-router-dom";
import * as loginApi from 'src/apis/login';
import { Creators } from 'src/store/ducks/login';

/**
 * Refresh user data on redux session upon page load.
 * @param {Object} props - Props for the AuthRouter component.
 * @param {React.ReactNode} props.children - The children elements.
 * @param {Object} [props] - Additional props to be spread on the AuthRouter component.
 * @returns {JSX.Element} The AuthRouter component.
 * @example
 *  <AuthRouter>
 *      {children}
 *  </AuthRouter>
 */
function AuthRouter({children, ...props}) {
    const dispatch = useDispatch();
    const history = useHistory();

    // refresh user data on redux session
    useEffect(() => {
        loginApi.getLoggedUser().then(response => {
            if(response.data.result) dispatch(Creators.setSessionUser(response.data.result));
        })
        .catch(error => {
            console.error("Erro ao buscar usuário logado:", error);
            history.push('/unauthentication'); 
        });
}, [dispatch, history]);

    return (
        <Route {...props}>{children}</Route>
    );
}

export default AuthRouter;